var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5a.5.5 0 01.09.992L7 3.5H4a1.5 1.5 0 00-1.493 1.356L2.5 5v9.116l4.243-2.545a.5.5 0 01.432-.04l.082.04 4.243 2.546V8a.5.5 0 01.41-.492L12 7.5a.5.5 0 01.492.41L12.5 8v7a.5.5 0 01-.679.467l-.078-.038L7 12.583l-4.743 2.846a.5.5 0 01-.75-.342L1.5 15V5a2.5 2.5 0 012.336-2.495L4 2.5h3zM12.016.175a.5.5 0 01.491.412l.008.09-.007 1.822 1.796.001a.5.5 0 01.09.992l-.09.008h-1.799L12.5 5.321a.5.5 0 01-.992.087l-.008-.09.005-1.82L9.69 3.5a.5.5 0 01-.09-.992l.09-.008h1.818l.007-1.826a.5.5 0 01.501-.499z",
    fill: "var(--icon-light-gray)",
    fillRule: "nonzero"
  })));
}
export default SvgBookmark;